<template>
  <div class="left-chart">
    <div class="header flex">
      <div class="tags">
        <span class="active">总消费趋势</span>
        <span v-if="false">ETC助手</span>
      </div>
      <div v-if="false" class="filter flex">
        <div class="time-btn flex">
          <span class="active">今日</span>
          <span>本周</span>
          <span>本月</span>
          <span>全年</span>
        </div>
        <div>
          <el-date-picker
            v-model="date"
            type="daterange"
            value-format="timestamp"
            class="margin-r-10"
            :size="$store.state.element.elBtnSize"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </div>
      </div>
    </div>
    <div class="content">
      <div id="myChart" :style="{ width: '100%', height: '366px' }" />
    </div>
  </div>
</template>
<script>
// 引入基本模板
let echarts = require('echarts/lib/echarts');
// 引入柱状图组件
require('echarts/lib/chart/bar');
// 引入提示框和title组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');

export default {
  data() {
    return {
      options: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          nameLocation: 'start',
          axisTick: {
            show: false,
            alignWithLabel: true,
          },
          axisLabel: {
            interval: 0,
            color: '#202C55',
            fontWeight: '500',
            fontFamily: '9ED14F53',
            fontSize: 14,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#  ',
              width: 2,
            },
          },

          data: [],
        },
        grid: {
          left: '30',
          top: '57',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#EBEEF5',
              width: 1,
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: '#202C55',
            fontWeight: '400',
            fontFamily: '9ED14F53',
            fontSize: 14,
          },
        },
        series: [
          {
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            type: 'bar',
            barWidth: 24,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#008FFF' },
                { offset: 1, color: '#2154bd' },
              ]),
              barBorderRadius: [100, 100, 0, 0],
            },
          },
        ],
      },
    };
  },
  computed: {
    axiosAll() {
      return this.$store.state.axiosAll;
    },
  },
  watch: {
    axiosAll: {
      handler(c) {
        this.$store.commit('upAxiosAll', c);
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.axiosAll) {
      let list = this.axiosAll;
      let xAxisArr = [],
        yAxisArr = [];
      list.forEach(item => {
        xAxisArr.push(Object.keys(item)[0]);
        yAxisArr.push(((Object.values(item)[0] || 0) / 100).toFixed(2));
      });
      this.options.series[0].data = yAxisArr;
      this.options.xAxis.data = xAxisArr;
    }
    this.draw('myChart');
  },

  methods: {
    draw(id) {
      let myChart = echarts.init(document.getElementById(id));
      myChart.setOption(this.options);
    },
  },
};
</script>
<style lang="scss" scoped>
@import url('./right.css');
.left-chart {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 7px 0px rgba(214, 214, 214, 0.5);
}
// @media screen and (max-width: 1679px) {
//     .left-chart {
//         position: absolute;
//         // width: 100%;
//     }
// }
.header {
  justify-content: space-between;
}
.content {
  height: 402px;
}
.filter {
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  span {
    color: #787f95;
    margin-right: 38px;
    cursor: pointer;
  }
  .active {
    font-size: 16px;
    color: rgba(18, 28, 64, 1);

    font-weight: 500;
  }
  span:last-child {
    margin-right: 50px;
  }
}
.tags {
  height: 25px;
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  color: rgba(18, 28, 64, 1);
  height: 53px;
  span {
    line-height: 53px;
    padding: 0 21px;
    height: 53px;
    display: inline-block;
    cursor: pointer;
  }
  .active {
    color: rgba(33, 84, 189, 1);
    position: relative;
    &::after {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 2px;
      content: '';
      width: 100%;
      background: rgba(33, 84, 189, 1);
    }
  }
}
</style>
